import { combineReducers } from "redux";
import groupsReducer from "./groupsReducer";
import mipsReducer from "./mipsReducer";
import modalReducer from "./modalReducer";
import risReducer from "./risReducer";
import sitesReducer from "./sitesReducer";
import usersReducer from "./usersReducer";
import hl7SentMessagesReducer from "./hl7SentMessagesReducer";
import hl7ReceivedMessagesReducer from "./hl7ReceivedMessagesReducer";
import visitsReportReducer from "./visitsReportReducer";
import examCodesReducer from "./examCodesReducer";

const adminReducer = combineReducers({
    modal: modalReducer,
    users: usersReducer,
    sites: sitesReducer,
    mips: mipsReducer,
    groups: groupsReducer,
    ris: risReducer,
    hl7SentMessages: hl7SentMessagesReducer,
    hl7receivedmessages: hl7ReceivedMessagesReducer,
    visitsReport: visitsReportReducer,
    examCodes:examCodesReducer
});

export default adminReducer;
